import React from "react";
import "./Header.css";

export default function Header() {
  return (
    <div className="header-container">
      <div className="header-text">
        <h2>Dashboard</h2>
      </div>
      <div className="header-bar">Dashboard</div>
    </div>
  );
}
